import { COLORS } from '@btime/constants'
import { concatIf } from '@btime/helpers'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React, { Fragment } from 'react'

import { Title } from '../../../components/presentation/Text'
import { useNavigation } from '../../../utils/contexts/NavigationContext'
import DropdownLink from '../../../components/navigation/DropdownLink'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconText from '../../../components/presentation/IconText'
import Separator from '../../../components/helpers/Separator'

const PageHeader = () => {
  const { t } = useTranslation(['common', 'listChecklists'])
  const navigate = useNavigation()

  const canSetup = useSessionPermission('setupChecklist')

  const options = [
    ...concatIf(canSetup, [
      {
        value: 'category',
        iconLeft: 'RiListSettingsLine',
        onClick: () => navigate('/minicruds/checkListCategory')
      }
    ])
  ]

  return (
    <Fragment>
      <Separator weight={12} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <Title size="h2" color={COLORS.dark3} noWrap>
            {t('listChecklists:title')}
          </Title>
        </FlexCol>

        {/* TODO: Take it back after migrate intercom articles to another place */}
        {/* <FlexCol>
          <PageGuide />
        </FlexCol> */}

        <FlexCol flex={1}></FlexCol>

        {!!options.length && (
          <FlexCol>
            <DropdownLink
              fromRight
              t={key => t(`listChecklists:menu.${key}`)}
              options={options}
              actionContent={
                <IconText label={t('moreOptions')} iconName="BsThreeDotsVertical" noWrap size="small" bold />
              }
            />
          </FlexCol>
        )}
      </FlexGrid>
      <Separator weight={2} />
    </Fragment>
  )
}

export default PageHeader
